<template>
  <div class="contact-item-wrapper">
    <router-link 
      :to="redirect ? navigateTo : ''" 
      class="contact-item" 
      @click.prevent="!redirect"
    >
      <woot-thumbnail :src="thumbnail" :username="name" size="24px" />
      <div class="contact-details">
        <h5 class="text-block-title name">{{ name }}</h5>
        <p class="details-meta">
          <span v-if="email" class="email">{{ email }}</span>
          <span v-if="phone" class="separator">•</span>
          <span v-if="phone" class="phone">
            {{ phone }}
          </span>
        </p>
      </div>
    </router-link>
    <woot-button
      v-tooltip="$t('CONTACT_PANEL.NEW_MESSAGE')"
      :title="$t('CONTACT_PANEL.NEW_MESSAGE')"
      class="new-message bg-primary"
      icon="chat"
      size="small"
      @click.stop="startConversation"
    />
  </div>
</template>

<script>
import { frontendURL } from 'dashboard/helper/URLHelper';
export default {
  props: {
    id: {
      type: [String, Number],
      default: 0,
    },
    email: {
      type: String,
      default: '',
    },
    phone: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    thumbnail: {
      type: String,
      default: '',
    },
    redirect: {
      type: Boolean,
      default: true,
    },
    accountId: {
      type: [String, Number],
      default: 0,
    },
  },
  computed: {
    navigateTo() {
      return frontendURL(`accounts/${this.accountId}/contacts/${this.id}`);
    },
  },
  methods: {
    startConversation() {
      this.$emit('start-conversation', this.id);
    },
  },
};
</script>

<style scoped lang="scss">
.contact-item-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-small);
  border-radius: var(--border-radius-small);
  
  &:hover {
    background-color: var(--s-25);
    
    .new-message {
      opacity: 1;
    }
  }
}

.contact-item {
  cursor: pointer;
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.contact-details {
  margin-left: var(--space-small);
  min-width: 0;
  flex: 1;
}

.name {
  margin: 0;
}

.details-meta {
  margin: 0;
  color: var(--s-600);
  font-size: var(--font-size-small);
  display: flex;
  align-items: center;

  span {
    margin-right: var(--space-smaller);
  }
}

.new-message {
  opacity: 0;
  transition: opacity 0.2s ease;
  flex-shrink: 0;
}
</style>
